class EnvironmentNames {
  static NAMES = {
    local: "Lokální prostředí",
    development: "Lokální prostředí",
    production: "Vývojové prostředí",
  };

  static CLOUD_NAMES = {
    unknown: "Nepojmenované prostředí",
    dev: "Vývojové prostředí",
    uat: "UAT prostředí",
    production: "Produkční prostředí",
  };

  static CLOUD_PROD = "production";

  static getCurrentName() {
    const nodeEnv = import.meta.env.MODE;
    const cloudEnv = import.meta.env.VITE_CLOUD_ENV;
    return this.getEnvName(nodeEnv, cloudEnv);
  }

  static getEnvName(nodeEnv, cloudEnv) {
    if (cloudEnv && this.CLOUD_NAMES[cloudEnv]) return this.CLOUD_NAMES[cloudEnv];
    return this.NAMES[nodeEnv] || this.CLOUD_NAMES.unknown;
  }

  static isCloudProd() {
    return import.meta.env.VITE_CLOUD_ENV === this.CLOUD_PROD;
  }
}

export default EnvironmentNames;
